import { AvatarWithLabel, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link, useRouteMatch } from 'react-router-dom';
import { useSettingsDrawer } from '../../hook';
import { getTitle, getSubtitle } from '../../utils';
import { ListItem, Icon, AlignRight } from './styled';
export function ListButton(props) {
    const { settingsKey, icon, endElement, disabled, loading } = props;
    const { onSelectSetting } = useSettingsDrawer();
    const { url } = useRouteMatch();
    const title = getTitle(settingsKey);
    const subtitle = getSubtitle(settingsKey);
    const link = `${url}/${settingsKey}`;
    const handleOnClick = () => {
        onSelectSetting(settingsKey);
    };
    return (<ListItem disabled={disabled} as={disabled ? 'div' : Link} to={disabled ? undefined : link} onClick={disabled ? undefined : handleOnClick}>
      <AvatarWithLabel appearance="light" shape="circle" size="lg" title={title} subtitle={subtitle}>
        {loading ? <Loader /> : icon}
      </AvatarWithLabel>

      <AlignRight>
        {endElement}
        {!disabled && (<Icon>
            <Falcon icon="chevron-right"/>
          </Icon>)}
      </AlignRight>
    </ListItem>);
}
